<template>
    <aside class="menu app-sidebar is-hidden-mobile">
        <ul class="menu-list">
            <li v-for="item in navItems">
                <router-link :to="{ name: item.path, params: {lang: lang} }" :exact="item.isExact" v-if="evaluate(item.condition)">
                   <span class="icon is-small">
                        <i class="fa fa-fw" :class="[item.icon]" aria-hidden="true"></i>
                   </span>
                    {{ item.name }}

                    <template v-for="child in item.children">
                        <span class="icon is-small is-pulled-right"
                              v-if="evaluate(child.condition)"
                        >
                            <i class="fa fa-fw"
                               :class="getRealClass(child)"
                               aria-hidden="true"
                               @click.prevent="showModal(child)"
                            />
                        </span>
                    </template>
                </router-link>

                <ul v-if="item.subRoutes">
                    <li
                        :key="route.name"
                        v-for="route in item.subRoutes"
                    >
                        <router-link :to="{ name: route.path, params: {lang: lang} }" :exact="item.isExact">
                            {{ $t(`generic.menu.${route.path}`) }}
                        </router-link>
                    </li>
                </ul>
            </li>
        </ul>
        <p class="menu-label" v-if="campgrounds && campgrounds.length > 1">{{ $t('generic.currentCampground') }}</p>
        <p class="control" v-if="campgrounds && campgrounds.length > 1">
          <span class="select">
            <select @change="changeCampground">
              <option v-for="option in campgrounds" :value="option.slug" :selected="campground.slug === option.slug">
                {{ option.name }}
              </option>
            </select>
          </span>
        </p>

        <Modal
            ref="modal"
            :title="$t('generic.formWarningsAndErrorsHeadline')"
        >
            <ol class="modal__list">
                <li
                    v-for="(content, index) in modalContent"
                    :key="index"
                >
                    <span class="icon is-small" v-if="content[0]">
                        <i class="fa fa-warning is-danger" v-if="content[0] === 'w'"></i>
                        <i class="fa fa-warning is-invalid" v-if="content[0] === 'e'"></i>
                    </span>
                    {{ content[1] }}
                </li>
            </ol>

            <template #footer>
                <button
                    class="button is-primary"
                    @click="toggleModal"
                >
                    {{ $t('generic.close') }}
                </button>
            </template>
        </Modal>
    </aside>
</template>

<script>
    import { AppModel } from '../../../models';
    import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse';
    import {EventBus} from '../../../utils';
    import Modal from '../modal/modal.vue';

    export default {
        name: 'sidebar',

        components: {
            Collapse,
            CollapseItem,
            Modal,
        },

        props: ['campground', 'campgrounds', 'checks'],

        data() {
            return {
                modalContent: null,
                navItems: [{
                    path: 'home',
                    icon: 'fa-eye',
                    name: this.$t('generic.menu.overview'),
                    isExact: true
                }, {
                    path: 'bookings',
                    icon: 'fa-list-alt',
                    name: this.$tc('generic.menu.bookings.bookings', 2)
                },
                {
                    path: 'availabilities-redirect',
                    icon: 'fa-table',
                    name: this.$t('generic.menu.availabilities'),
                    children: [{
                        condition: 'this.hasAvailabilityCheck && this.checks && !this.checks.availabilities',
                        warnings: 'this.checks.availabilities_warnings',
                        errors: 'this.checks.availabilities_errors',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                },
                // {
                //     path: 'payments',
                //     icon: 'fa-money',
                //     name: this.$t('generic.menu.payments'),
                // }, {
                //     path: 'invoices',
                //     icon: 'fa-file-pdf-o',
                //     name: this.$t('generic.menu.invoices'),
                // },
                {
                    path: 'dayprices',
                    icon: 'fa-money',
                    name: this.$t('generic.menu.pricelist'),
                },
                // {
                //     path: 'seasons',
                //     icon: 'fa-calendar',
                //     name: this.$t('generic.menu.seasons'),
                //     children: [{
                //         condition: 'this.checks && !this.checks.seasons',
                //         warnings: 'this.checks.seasons_warnings',
                //         errors: 'this.checks.seasons_errors',
                //         icon: 'fa-exclamation-triangle is-invalid',
                //     }]
                // }
                {
                    path: 'cancellation-terms',
                    icon: 'fa-list-ol',
                    name: this.$t('generic.menu.cancellation.sidebar'),
                    children: [{
                        condition: 'this.checks && !this.checks.cancellations',
                        warnings: 'this.checks.cancellations_warnings',
                        errors: 'this.checks.cancellations_errors',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                },
                {
                    path: 'campsites',
                    icon: 'fa-map-marker',
                    name: this.$t('generic.menu.campsites'),
                    children: [{
                        condition: 'this.checks && !this.checks.campsites',
                        warnings: 'this.checks.campsites_warnings',
                        errors: 'this.checks.campsites_errors',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                }, {
                    path: 'pms-accommodations',
                    icon: 'fa-home',
                    name: this.$t('pms.menuLabel'),
                    condition: 'this.owner_frontend_config && this.owner_frontend_config.pms_objects',
                }, {
                    path: 'persons',
                    icon: 'fa-user-circle',
                    name: this.$t('generic.menu.persons'),
                    children: [{
                        condition: 'this.checks && !this.checks.persons',
                        warnings: 'this.checks.persons_warnings',
                        errors: 'this.checks.persons_errors',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                }, {
                    path: 'extras',
                    icon: 'fa-plus-circle',
                    name: this.$t('generic.menu.extras'),
                    children: [{
                        condition: 'this.checks && !this.checks.extras',
                        warnings: 'this.checks.extras_warnings',
                        errors: 'this.checks.extras_errors',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                }, {
                    path: 'portals',
                    icon: 'fa-laptop',
                    name: this.$t('generic.menu.portals'),
                }, {
                    path: 'translations',
                    icon: 'fa-globe',
                    name: this.$t('generic.menu.translations'),
                    children: [{
                        condition: 'this.checks && !this.checks.translations',
                        warnings: 'this.checks.translations_warnings',
                        errors: 'this.checks.translations_errors',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                }, {
                    path: 'settings',
                    icon: 'fa-cogs',
                    name: this.$t('generic.menu.settings'),
                    children: [{
                        condition: 'this.checks && !this.checks.settings',
                        warnings: 'this.checks.settings_warnings',
                        errors: 'this.checks.settings_errors',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }],
                }],
                hasAvailabilityCheck: false,
                owner_frontend_config: {}
            };
        },

        created() {
            EventBus.$on(EventBus.BOOTSTRAP_DONE, this.onBootstrapDone);
        },

        computed: {
            lang() {
                return AppModel.lang;
            },
        },

        methods: {
            onBootstrapDone() {
                if(AppModel.activeCampground) {
                    this.hasAvailabilityCheck = AppModel.activeCampground.settings.pms_api_active;
                    this.owner_frontend_config = AppModel.activeCampground.settings.owner_frontend_config;
                    console.log('onBootstrapDone', this.owner_frontend_config);
                }
            },

            changeCampground(event) {
                this.$router.push({name: 'change-campground', params: {campground: event.target.value}});
            },

            evaluate(str) {
                if(typeof str !== 'string') return true;
                // eslint-disable-next-line no-eval
                return eval(str);
            },
            getRealClass(child) {
                const warnings = this.evaluate(child.warnings);
                const errors = this.evaluate(child.errors);
                if(errors.length === 0 && warnings.length > 0) {
                    return 'fa-warning is-danger';
                }
                return child.icon;
            },
            showModal(data) {
                this.toggleModal();
                let result = [];
                const arrayErrors = this.evaluate(data.errors);
                for(let i = 0; i < arrayErrors.length; i++) {
                    result.push(['e', arrayErrors[i]]);
                }
                const arrayWarnings = this.evaluate(data.warnings);
                for(let i = 0; i < arrayWarnings.length; i++) {
                    result.push(['w', arrayWarnings[i]]);
                }
                this.modalContent = result;
            },
            toggleModal() {
                this.$refs.modal.toggleModal();
            }
        },
    };
</script>

<style lang="scss">
    @import 'sidebar.scss';
</style>

<style lang="scss" scoped>
    .modal {
        &__list {
            margin-left: 2rem;

            .icon {
                &.is-small {
                    vertical-align: baseline;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/components/sidebar/sidebar.vue